module.exports = __webpack_public_path__ + "static/img/yushin.1d37537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/yushin.jpg
// module id = /FUc
// module chunks = 1